/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_1_PInputs */

const en_cp_cmp_1_p = /** @type {(inputs: Cp_Cmp_1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P2MW · PKM · Wirausaha Merdeka`)
};

const id_cp_cmp_1_p = /** @type {(inputs: Cp_Cmp_1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`P2MW · PKM · Wirausaha Merdeka`)
};

/**
* | output |
* | --- |
* | "P2MW · PKM · Wirausaha Merdeka" |
*
* @param {Cp_Cmp_1_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_1_p = /** @type {((inputs?: Cp_Cmp_1_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_1_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_1_p(inputs)
	return en_cp_cmp_1_p(inputs)
});